import './ByNamirial.css';

export const ByNamirial = () => {
    return (
        <img className="vid-copyright" src="https://stvidpublicassets.blob.core.windows.net/vidsigner/by%20namirial.png" />
    );
};